import { createContext, type ReactNode, useContext, useEffect, useState } from "react";

type ScreenWidthContext = {
	xs: boolean;
	sm: boolean;
	lg: boolean;
}

const ScreenWidthContext = createContext<ScreenWidthContext | undefined>(undefined);

export function ScreenWidthProvider({ children }: { children: ReactNode }) {
	const [screenWidthLessThan, setScreenWidthLessThan] = useState({
		xs: typeof window !== "undefined" && window.matchMedia("(max-width: 550px)").matches,
		sm: typeof window !== "undefined" && window.matchMedia("(max-width: 785px)").matches,
		lg: typeof window !== "undefined" && window.matchMedia("(max-width: 1735px)").matches,
	});

	useEffect(() => {
		const updateScreenSize = () => {
			setScreenWidthLessThan({
				xs: window.matchMedia("(max-width: 550px)").matches,
				sm: window.matchMedia("(max-width: 785px)").matches,
				lg: window.matchMedia("(max-width: 1735px)").matches,
			});
		};

		updateScreenSize();
		window.addEventListener("resize", updateScreenSize);

		return () => {
			window.removeEventListener("resize", updateScreenSize);
		};
	}, []);

	return <ScreenWidthContext.Provider value={screenWidthLessThan}>{children}</ScreenWidthContext.Provider>;
}

export function useScreenWidth() {
	const context = useContext(ScreenWidthContext);
	if (context === undefined) {
		throw new Error("useScreenWidth must be used within a ScreenWidthProvider");
	}
	return context;
}
